import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var detailsRoute = [{
  path: "details/:id/:sale",
  name: "details",
  component: function component() {
    return import("./details.vue");
  }
}];